import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import History from './AppHistory';
import Constants from './Constants';

import * as NotificationsStore from './store/notifications';

import * as signalR from '@microsoft/signalr';

import './i18n';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './styles/index.scss';

import * as AppActions from './store/app';
import { MessageType, parseMessage } from '@models/notifications';

(window as any).process = {
    ...(window as any).process,
};

const signalConnection = new signalR.HubConnectionBuilder()
    .withUrl("/notifications")
    // .configureLogging(signalR.LogLevel.Information)
    .withAutomaticReconnect()
    .build();

async function startSignalNotifications() {
    try {
        await signalConnection.start();
    }
    catch (err) {
        console.log(err);
        setTimeout(startSignalNotifications, 5000);
    }
};

if (!window.location.pathname.startsWith('/mobile')) {

    // Create browser history to use in the Redux store
    const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;

    // Get the application-wide store instance, prepopulating with state from the server where available.
    const store = configureStore(History);
    AppActions.actionCreators.initialize()(store.dispatch);


    signalConnection.onclose(async () => {
        await startSignalNotifications();
    });

    let __last_reloadns = new Date().getTime();

    signalConnection.on('NotificationMessage', rawMessage => {
        const message = parseMessage(rawMessage);
        if (message.notificationType == MessageType.RELOAD_NOTIFICATIONS) {
            const cs = new Date().getTime();
            if (cs - __last_reloadns > 1000 * 30) {

                const randomTime = Math.floor(Math.random() * (10 * 1000));

                setTimeout(() => {
                NotificationsStore.actionCreators.addMessage(message)(store.dispatch, store.getState);
                }, randomTime);
            }
        }
        else {
            NotificationsStore.actionCreators.addMessage(message)(store.dispatch, store.getState);
        }
    });
    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={History}>
                <App />
            </ConnectedRouter>
        </Provider>,
        document.getElementById('root'));

    if (Constants.isDebug) {
        registerServiceWorker();
    }

    setTimeout(
        () => {
            NotificationsStore.actionCreators.loadMessages()(store.dispatch, store.getState);
            startSignalNotifications();
        },
        1000);

}